import { understandingColorSections } from "../data/understanding-color-sections";

export function prepareArticleMarkup(source: string): string {
  const mainContent = source.match(/<main\b[^>]*>([\s\S]*?)<\/main>/i)?.[1];
  if (!mainContent) {
    throw new Error("The color reference HTML is missing its main content.");
  }

  const articleMarkup = mainContent
    .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, "")
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, "")
    .replace(/<header\b[^>]*>[\s\S]*?<\/header>/i, "")
    .replace(/<section\b[^>]*\bid=["']future["'][^>]*>[\s\S]*?<\/section>/i, "")
    .replace(/<footer\b[^>]*>[\s\S]*?<\/footer>/gi, "")
    .replace(/<h3\b/gi, "<h4")
    .replace(/<\/h3>/gi, "</h4>")
    .replace(/<h2\b/gi, "<h3")
    .replace(/<\/h2>/gi, "</h3>")
    .replace(
      /<a\b([^>]*?)\bhref=(["'])(https?:\/\/[^"']+)\2([^>]*)>/gi,
      (_match, before, quote, url, after) =>
        `<a${before}href=${quote}${url}${quote}${after} target="_blank" rel="noopener noreferrer">`,
    );

  return understandingColorSections.reduce((markup, [id, label]) => {
    const openingTag = new RegExp(`<section\\b(?=[^>]*\\bid=["']${id}["'])[^>]*>`, "i");
    const safeLabel = label.replaceAll("&", "&amp;").replaceAll('"', "&quot;");
    const controls = `
      <div class="color-reference-section-actions">
        <button
          type="button"
          class="color-reference-section-link"
          data-section-link-id="${id}"
          aria-label="Copy link to ${safeLabel}"
        >Copy link</button>
        <span class="color-reference-section-feedback" data-section-link-feedback role="status" aria-live="polite" aria-atomic="true"></span>
      </div>`;
    return markup.replace(openingTag, (sectionTag) => `${sectionTag}${controls}`);
  }, articleMarkup);
}
